import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AvatarIcon } from '@mri-platform/shared/common-types';
import { ButtonIconComponent } from '@mri-platform/ui-icon';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DIALOG } from '@progress/kendo-angular-dialog';
import { AvatarIconSelectorResult, AvatarIconSelectorResultType } from '../../models/avatar-icon-selector-result';
import { AvatarIconSelectorFormComponent } from '../avatar-icon-selector-form/avatar-icon-selector-form.component';
@Component({
  standalone: true,
  selector: 'mri-shared-avatar-icon-selector-popup',
  imports: [KENDO_BUTTON, KENDO_DIALOG, ButtonIconComponent, AvatarIconSelectorFormComponent],
  template: `
    <kendo-dialog title="Select Icon" (close)="cancel()" [minWidth]="450" [width]="550">
      <mri-shared-avatar-icon-selector-form
        [value]="value"
        (validChanges)="setCanSave($event)"
        (valueChanges)="setCurrentValue($event)"
      ></mri-shared-avatar-icon-selector-form>
      <kendo-dialog-actions>
        <button
          data-testid="mri-shared-avatar-icon-selector-popup-ok-button"
          kendoButton
          [primary]="true"
          (click)="accept()"
          [disabled]="!canSave"
        >
          <mri-btn-icon icon="checkmark"></mri-btn-icon>
          OK
        </button>
        <button
          data-testid="mri-shared-avatar-icon-selector-popup-cancel-button"
          kendoButton
          look="outline"
          (click)="cancel()"
        >
          <mri-btn-icon icon="x"></mri-btn-icon>
          Cancel
        </button>
      </kendo-dialog-actions>
    </kendo-dialog>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarIconSelectorPopupComponent {
  @Input() value?: AvatarIcon;
  canSave = false;
  @Output() action = new EventEmitter<AvatarIconSelectorResult>();

  private currentValue?: AvatarIcon;

  setCurrentValue(value: AvatarIcon) {
    this.currentValue = value;
  }

  setCanSave(value: boolean) {
    this.canSave = value;
  }

  accept() {
    this.action.emit(this.createResult('accept'));
  }

  cancel() {
    this.action.emit(this.createResult('cancel'));
  }

  private createResult(resultType: AvatarIconSelectorResultType): AvatarIconSelectorResult {
    if (resultType === 'accept' && this.currentValue) {
      return { type: 'accept', data: { value: this.currentValue } };
    } else {
      return { type: 'cancel' };
    }
  }
}
